import { render, staticRenderFns } from "./zhangHao.vue?vue&type=template&id=136c6cc9&scoped=true&"
import script from "./zhangHao.vue?vue&type=script&lang=js&"
export * from "./zhangHao.vue?vue&type=script&lang=js&"
import style0 from "./zhangHao.vue?vue&type=style&index=0&id=136c6cc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c6cc9",
  null
  
)

export default component.exports